module.exports = __webpack_public_path__ + "img/linkedin.2e4767ec.svg";